import React from 'react';
import currencyFormatter from 'currency-formatter';

export const jsonToStyle = (json) => {
  const selectors = Object.keys(json);
  return selectors
    .map((selector) => {
      const definition = json[selector];
      const rules = Object.keys(definition);
      const result = rules
        .map((rule) => {
          return `${rule}:${definition[rule]}`;
        })
        .join(';');
      return `${selector}{${result}}`;
    })
    .join('\n');
};

export const isUUID = (uuid) => {
  let s = '' + uuid;
  s = s.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
  return !!s;
};

export const isWeaslEvent = (event) => {
  return !!event && event.data && event.data.type;
}

export function getRatesList(country, amount, currencies) {
  const currenciesList = currencies?.map((i) => i.currencies.map((x) => x?.iso));

  let requests = currenciesList?.map((item) =>
    item.map((item) => `exchange-rates/exchange?currencyFrom=${country}&amount=${amount}&currencyTo=${item}`)
  );

  requests = [].concat.apply([], requests);

  return (requests = [...new Set(requests)]);
}

export function getUniqueListByKey(arr, key) {
  return [...new Map(arr.map((item) => [item[key], item])).values()];
}

export function getAmountWithIso(array) {
  const result = array?.map(item => ({ iso: item.config.url.slice(-3), amount: item.data }))
  return result
}

export function mergeObjectsWithSameKeys(objectOne, objectTwo) {
  return objectOne?.map(x => ({ ...x, ...objectTwo.find(y => y?.iso === x?.iso) }))
}

 export function mapStylesFromMerchant1(styles) {
  if (styles) {
    const objJson = JSON.parse(styles);
    const mappedStyles = [objJson].map((style) => ({
        '@font-face': style?.primary_font?style?.primary_font:"",
        '@font-face ': style?.secondary_font?style?.secondary_font:"",
        '*':{
            'font-family': style?.input_label_text?.['font-family'],
            'color': style?.input_label_text?.color
        },
        '.input_label_text': style?.input_label_text?style?.input_label_text:"",
        '.fx_conversion_text': style?.fx_conversion_text?style?.fx_conversion_text:"",
        '.pay_method_text':style?.pay_method_text?style?.pay_method_text:"",
        '.country_text':style?.country_text?style?.country_text:"",
        '.error_text':style?.error_text?style?.error_text:"",
        '.divider_text':style?.divider_text?style?.divider_text:"",
        '.fx_switcher_text':style?.fx_switcher_text?style?.fx_switcher_text:"",
        '.product_moredetails':style?.product_moredetails?style?.product_moredetails:"",
        '.page_body':style?.page_body?style.page_body:"",
        '.amount_title': style?.amount_title?style.amount_title:"",
        '.product_amount': style?.product_amount?style.product_amount:"",
        '.payment_plan_link': style?.payment_plan_link?style.payment_plan_link:"",
        '.payment_plan_title': style?.payment_plan_title?style.payment_plan_title:"",
        '.payment_plan_label': style?.payment_plan_label?style.payment_plan_label:"",
        '.payment_plan_amount': style?.payment_plan_amount?style.payment_plan_amount:"",
        '.accept_terms': style?.accept_terms?style.accept_terms:"",
        '.policy_text': style?.policy_text?style.policy_text:"",
        '.back_link': style?.back_link?style.back_link:"",
        '.product_details': style?.product_details?style.product_details:"",
        '.product_text': style?.product_text?style.product_text:"",
        '.product_subtext': style?.product_text?style.product_subtext:"",
        '.MuiInputBase-root.Mui-error': style?.error_border?style?.error_border:"",
        '.ElementsApp.InputElement.is-invalid':{
            color:style?.error_text? style?.error_text?.color:""
        },
        '.MuiButtonBase-root.Mui-selected':style?.control_selected_border?style?.control_selected_border:"",
        '.save_card_switch_default':style?.save_card_switch_default ? style?.save_card_switch_default :"",
        '.save_card_switch_active':style?.save_card_switch_active ? style?.save_card_switch_active :"",
        '.save_card_text_default':style?.save_card_text_default ? style?.save_card_text_default :"",
        '.save_card_text_active':style?.save_card_text_active ? style?.save_card_text_active :"",
        '.MuiInputBase-input': style['MuiInputBase-input'] ? style['MuiInputBase-input'] : '',
        '.MuiInputBase-root': style['MuiInputBase-root'] ? style['MuiInputBase-root'] : '',
        '.rootFormWrapper': style.rootFormWrapper ? style.rootFormWrapper : '',
        '.formElement': style.formElement ? style.formElement : '',
        '.brandsWrapper': style.brandsWrapper ? style.brandsWrapper : '',
        '.currency-toggle': style['MuiInputBase-input'] ? style['MuiInputBase-input'] : '',
    }));
    return mappedStyles[0];
  }
}

export function mapStylesFromMerchant(styles) {
  if (styles) {
    const mappedStyles = [styles].map((style) => ({
      '*': {
        'color': style.textColor,
        'font-family': style.textFont
      },

      '.container': {
        'background': style.background
      },

      '.makeStyles-amount-7': {
        'color': style.textColor,
        'font-family': style.textFont
      },

      '.makeStyles-cardText-19': {
        'color': style.textColor,
        'font-family': style.textFont
      },

      '.makeStyles-postalText-26': {
        'color': style.textColor,
        'font-family': style.textFont
      },

      '.makeStyles-currenciesHeaderText-29': {
        'color': style.textColor,
        'font-family': style.textFont
      },

      '.makeStyles-hr-14': {
        'color': style.textColor,
        'font-family': style.textFont
      },

      ".makeStyles-hr-14::before": {
        'background': style.textColor
      },

      ".makeStyles-hr-14::after": {
        'background': style.textColor
      },

      '.jss7': {
        'color': style.textColor,
        'font-family': style.textFont
      },

      '.jss8': {
        'color': style.textColor,
        'font-family': style.textFont
      },


      '.jss14': {
        'color': style.textColor,
        'font-family': style.textFont
      },

      ".jss14::before": {
        'background': style.textColor
      },

      ".jss14::after": {
        'background': style.textColor
      },

      '.jss19': {
        'color': style.textColor,
        'font-family': style.textFont
      },

      '.jss26': {
        'color': style.textColor,
        'font-family': style.textFont
      },

      '.jss29': {
        'color': style.textColor,
        'font-family': style.textFont
      },

      '.continueButton': {
        'background': style.continueButtonColor,
        'color': style.continueButtonTextColor,
        'font-family': style.textContinueButton
      },
      '.continueButton:hover': {
        'background': style.continueButtonColor
      },
      '.backButton': {
        'background': style.backButtonColor,
        'color': style.backButtonTextColor,
        'font-family': style.textBackButton
      },
      '.backButton:hover': {
        'background': style.backButtonColor
      }
    }));
    return mappedStyles[0];
  }
}

export const selectedLanguage = (lng) => {
  return lng === 'zh' ? 'zhCN' : lng === 'en' ? 'enUS' : lng;
}
export const DateFormat = (lng) => {
  return lng === 'zh' ? 'iii, yyyy年 MMM dd日' : lng === 'en' ? 'iii, dd MMM yyyy' : 'iii, dd MMM yyyy';
}

export const zeroDecimalCurrency = (currencyItem) => {
  return currencyItem && !currencyItem.decimals;
  // switch (currency) {
  //   case 'BIF':
  //     return true;
  //   case 'CLP':
  //     return true;
  //   case 'DJF':
  //     return true;
  //   case 'GNF':
  //     return true;
  //   case 'JPY':
  //     return true;
  //   case 'KMF':
  //     return true;
  //   case 'KRW':
  //     return true;
  //   case 'MGA':
  //     return true;
  //   case 'PYG':
  //     return true;
  //   case 'RWF':
  //     return true;
  //   case 'UGX':
  //     return true;
  //   case 'VND':
  //     return true;
  //   case 'VUV':
  //     return true;
  //   case 'XAF':
  //     return true;
  //   case 'XOF':
  //     return true;
  //   case 'XPF':
  //     return true;
  //   default:
  //     return false;
  // }
}

export const CurrencyFormats = (amount, precision = 2) => {
  return currencyFormatter.format(amount, { code: '', precision });
}

export const PaymentModes = {
  PayNow: 0,
  PayLater: 1,
  Token: 2,
  Terminal: 3,
  Authorize: 4,
}
export const languages = [
  { name: "العربية", code: "ar", dir: "rtl" },
];

function formatDate(value, format, lng) {
  const options = toOptions(format, "date");
  return options === null
    ? value
    : new Intl.DateTimeFormat(lng, options).format(value);
}
function formatNumber(value, format, lng) {
  const options = toOptions(format, "number");
  return options === null
    ? value
    : new Intl.NumberFormat(lng, options).format(value);
}
function toOptions(format, specifier) {
  if (format.trim() === specifier) {
    return {};
  } else {
    try {
      return JSON.parse(toJsonString(format, specifier));
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}
function toJsonString(format, specifier) {
  const inner = format
    .trim()
    .replace(specifier, "")
    .replace("(", "")
    .replace(")", "")
    .split(";")
    .map((param) =>
      param
        .split(":")
        .map((name) => `"${name.trim()}"`)
        .join(":"),
    )
    .join(",");
  return "{" + inner + "}";
}
export const format = (value, format, lng) => {

  if (format.startsWith("date")) {
    return formatDate(value, format, lng);
  }
  if (format.startsWith("number")) {
    return formatNumber(value, format, lng);
  }
  return value;
}

export const formatNumberToLocaleString = (number) => {
  // convert input to a number if it's a string
  const num = Number(number);
  // check if input is a valid number
  if (isNaN(num)) {
    throw new Error('Invalid input');
  }
  // use toLocaleString to format the number with commas
  const formatted = num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  // remove the decimal point and trailing zeros if there are any
  return formatted.replace(/(\.|,)0+$/, '');
}

export const transformToYYYY = (yearString) => {
    const yearPrefix = '20';
    return parseInt(yearPrefix + yearString, 10);
}

export const insertIntoArray = (arr, index, ...newItems) => [
  ...arr.slice(0, index),
  ...newItems,
  ...arr.slice(index)
]
